import type { GuideMaterial, HeroSlide } from "@/types";

export function getGuideVideoPoster(slide: HeroSlide | GuideMaterial) {
  const poster =
    "asset" in slide
      ? slide.asset.preview_url
      : slide.video && slide.image !== slide.video
        ? slide.image
        : undefined;
  return typeof poster === "string" && poster.trim() ? poster : undefined;
}

// iOS may leave a metadata-only video blank until Play. A tiny media fragment
// requests an initial frame when there is no poster, without autoplaying.
// Keep supplied fragments (including intentional start times) unchanged.
export function withVideoPreviewFrame(
  source: string | undefined,
  poster?: string,
) {
  return source && !poster && !source.includes("#")
    ? `${source}#t=0.001`
    : source;
}
